export const boardOptions = [
  { value: "CRM", label: "CRM" },
  { value: "CRO", label: "CRO" },
  { value: "COREN", label: "COREN" },
];
